// Current Claude design: 44x24 general pill; 36x20 payment/model variant.
// The shared theme and the settings compatibility export use this one owner.
export const switchSx = {
  width: 44,
  height: 24,
  padding: 0,
  overflow: "visible",
  "& .MuiSwitch-switchBase": {
    padding: "2px",
    color: "#FFFFFF",
    transition: "transform 150ms ease",
    "&.Mui-checked": {
      color: "#FFFFFF",
      transform: "translateX(20px)",
      "& + .MuiSwitch-track": {
        backgroundColor: "#10B981",
        opacity: 1,
      },
    },
    "&.Mui-focusVisible + .MuiSwitch-track": {
      outline: "2px solid #E1A731",
      outlineOffset: 2,
    },
    "&.Mui-disabled": {
      color: "#FFFFFF",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
    "&.Mui-disabled.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#10B981",
      opacity: 0.5,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
    height: 20,
    width: 20,
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#9E9E9E",
    borderRadius: 999,
    opacity: 1,
    transition: "background-color 150ms ease",
  },
  "&.MuiSwitch-sizeSmall": {
    width: 36,
    height: 20,
    "& .MuiSwitch-thumb": { width: 16, height: 16 },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(16px)",
    },
  },
} as const;

// An inactive membership model or hidden ticket has an explicit red OFF state.
export const modelOffRedSwitchSx = {
  ...switchSx,
  "& .MuiSwitch-track": {
    ...switchSx["& .MuiSwitch-track"],
    backgroundColor: "#E24C4C",
  },
} as const;

export const eventSwitchSx = {
  ...switchSx,
  "& .MuiSwitch-track": {
    ...switchSx["& .MuiSwitch-track"],
    backgroundColor: "#C7C7C7",
  },
} as const;
